var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.options.textSizeClass]},[_vm._v(" کد ملی: "+_vm._s(_vm.nationalCode)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }